<template>
    <div>
        <div id="page">
            <Header></Header>
        <div class="swipe01">
            <div class="swipe01-head swipe01-tr">
                <div class="swipe01-td">序号</div>
                <div class="swipe01-td">项目名称</div>
                <div class="swipe01-td">预约时间</div>
                <div class="swipe01-td">当前状态</div>
            </div>
            <div class="swipe01-body">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <van-swipe-cell class="wrap" :right-width="rightWidth" v-for="(item, index) in list">
                        <div class="swipe01-tr">
                            <div class="swipe01-td">{{ index+1 }}</div>
                            <div class="swipe01-td">{{ item.project_name }}</div>
                            <div class="swipe01-td">{{ item.re_appoint_time }}</div>
                            <div class="swipe01-td">{{ item.status_nm }}</div>
                        </div>
                        <div class="swipe01-tool" slot="right">
                            <div class="btn s1" @click='viewUserAppoint(item.appoint_id)'>查看</div>
                            <div class="btn s1" v-if="item.status=='cancel'" @click='showCancel(item.appoint_id)'>取消</div>
                        </div>
                    </van-swipe-cell>
                </van-list>
            </div>
        </div>
        </div>

        <Footer></Footer>

        <van-popup v-model="showPop" :overlay="true">
            <div class="pop-consign">
                <div class="close" @click="showPop = false"></div>
                <div class="consign-info">
                    <div class="consign-item">
                        <div class="lab">房源名称</div>
                        <div class="val">{{ appoint.project_name }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">预约日期</div>
                        <div class="val">{{ appoint.re_appoint_time }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">预约人</div>
                        <div class="val">{{ appoint.creator_name }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">联系电话</div>
                        <div class="val">{{ appoint.creator_phone }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">预约状态</div>
                        <div class="val">{{ appoint.status_nm }}</div>
                    </div>
                    <div class="consign-item" v-if="appoint.status=='cancel'">
                        <div class="lab">取消原因</div>
                        <div class="val">{{ appoint.detailed_reasons }}</div>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="cancelPop" :overlay="true">
            <div class="formw01 pop-form">
                <div class="close" @click="cancelPop = false"></div>
                <div class="formw01-tit">确认取消本次预约吗？</div>
                <div class="formw01-item">
                    <div class="formw01-lab">取消原因</div>
                    <div class="formw01-val">
                        <select class="formw01-sel" name="type" @change="selectVal">
                            <option :value="item" v-for="(item, index) in cancelList">{{ item }}</option>
                        </select>
                    </div>
                </div>
                <div class="formw01-item">
                    <div class="formw01-lab">详细原因</div>
                    <div class="formw01-val">
                        <textarea class="formw01-area" v-model="detail"></textarea>
                    </div>
                </div>
                <div class="formw01-item-ft">
                    <div class="btn s1" @click="resetEdit">取　消</div>
                    <div class="btn s2" @click="closeUserAppoint">提　交</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script scoped>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { SwipeCell, Popup, Dialog, Toast, List } from 'vant'

    export default {
        name: "UserBidedList",
        data: function () {
            return {
                rightWidth: document.body.clientWidth/750*200,
                showPop: false,
                cancelPop: false,
                loading: false,
                finished: false,
                cancelList: {},
                appoint_id: '',
                type: '',
                detail: '',
                list: [],
                page: 1,
                appoint: {}
            }
        },
        components: {
            Header, Footer,
            [SwipeCell.name]: SwipeCell,
            [Dialog.name]: Dialog,
            [Popup.name]: Popup,
            [Toast.name]: Toast,
            [List.name]: List
        },
        mounted(){
            this.getList();
            this.cancelLationreason();
        },
        methods: {
            getList () {
                const _this = this;
                _this.api.getUserAppointList({
                    page: _this.page,
                    pageSize: 20
                }).then(function(response){
                    _this.loading = false;
                    _this.page++;
                    for (let i in response.appoint_list) {
                        response.appoint_list[i].re_appoint_time = _this.formatTime(response.appoint_list[i].appoint_time, '{y}-{m}-{d}')
                    }
                    if (response.appoint_list.length < 20) {
                        _this.finished = true;
                    }
                    _this.list = _this.list.concat(response.appoint_list);
                })
            },
            cancelLationreason(){
                const _this = this;
                _this.api.cancelLationreason().then(function(response){
                    _this.cancelList = response
                })
            },
            viewUserAppoint (id) {
                const _this = this;
                let params = new FormData();
                params.append('appoint_id', id);
                _this.api.getUserAppointView(params).then(function(response){
                    _this.showPop = true;
                    _this.appoint = response.appoint;
                    _this.appoint.re_appoint_time = _this.formatTime(_this.appoint.appoint_time, '{y}-{m}-{d}')
                })
            },
            selectVal(el){
                this[el.target.name] = el.target.value
            },
            resetEdit(){
                this.cancelPop = false;
                this.detail = '';
                this.type = '';
            },
            showCancel(id){
                this.cancelPop = true;
                this.appoint_id = id
            },
            closeUserAppoint(){
                const _this = this;
                let params = new FormData();
                params.append('appoint_id', _this.appoint_id);
                params.append('cancellation_reason', _this.type);
                params.append('detailed_reasons', _this.detail);
                _this.api.cancelUserAppoint(params).then(function(response){
                    Toast(response.msg)
                    _this.cancelPop = false;
                    _this.page = 1;
                    _this.list = [];
                    _this.getList();
                })
            },
            onLoad(){
                setTimeout(()=>{
                    this.getList();
                }, 500)
            }
        }
    }
</script>

<style scoped>
    /deep/ .swipe01-tool {width: 2rem;}
    /deep/ .formw01-item-ft {padding: .2rem 0 0;}
    /deep/ .formw01-item-ft .btn {line-height: .5rem;font-size: .25rem;width: 32%;}
</style>
